'use client';

import React from 'react';
import Link from 'next/link';

const concepts = [
  { label: 'CREATION AS CLASSROOM', desc: 'Every element of the environment is a teacher. The horizon is a lesson. The tree is a text. The sky is a sign.' },
  { label: 'AYAT IN THE HORIZONS', desc: 'Quran 41:53 — Soon We will show them Our Signs in the horizons and in themselves until it becomes clear that it is the Truth.' },
  { label: 'DOMAIN EXPANSION', desc: 'Awareness of the ever-present veil. The curriculum keys expand your domain of perception — what was invisible becomes legible.' },
  { label: 'THE VEIL BECOMES VISIBLE', desc: 'The bridge is not a destination but a passage. From the internal keys to the external world — the same reality, newly perceived.' },
];

export default function BridgeEnvTransition() {
  return (
    <section className="py-20 border-t" style={{ background: 'rgba(10,20,16,0.7)', borderColor: 'rgba(139,105,20,0.15)' }}>
      <div className="max-w-[1280px] mx-auto px-6 lg:px-8">

        {/* Transition label */}
        <div className="flex items-center gap-4 mb-12">
          <div className="h-px flex-1" style={{ background: 'linear-gradient(90deg, transparent, rgba(139,105,20,0.3))' }} />
          <div className="text-center">
            <p className="font-mono text-[9px] tracking-widest uppercase mb-1" style={{ color: 'rgba(139,105,20,0.5)' }}>Bridge 01 · Passage</p>
            <p className="font-mono text-xs tracking-widest uppercase" style={{ color: 'rgba(245,240,232,0.25)' }}>Keys to Kulli Haal → Environment Design</p>
          </div>
          <div className="h-px flex-1" style={{ background: 'linear-gradient(90deg, rgba(139,105,20,0.3), transparent)' }} />
        </div>

        {/* Quran verse */}
        <div className="max-w-2xl mx-auto text-center mb-14">
          <p className="font-mono text-xs tracking-widest mb-4" style={{ color: 'rgba(245,240,232,0.2)' }}>Quran 41:53</p>
          <blockquote className="font-mono text-sm md:text-base leading-relaxed" style={{ color: 'rgba(245,240,232,0.45)' }}>
            &ldquo;Soon We will show them Our Signs in the horizons and in themselves until it becomes clear that it is the Truth.&rdquo;
          </blockquote>
        </div>

        {/* Concepts grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-px mb-12" style={{ background: 'rgba(139,105,20,0.1)' }}>
          {concepts?.map((c) => (
            <div key={c?.label} className="p-8 transition-colors duration-300" style={{ background: 'rgba(10,20,16,0.8)' }}
              onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.background = 'rgba(28,43,37,0.6)'; }}
              onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.background = 'rgba(10,20,16,0.8)'; }}
            >
              <p className="font-mono text-xs font-black tracking-widest uppercase mb-4" style={{ color: 'rgba(179,138,42,0.7)' }}>{c?.label}</p>
              <p className="font-mono text-sm leading-relaxed" style={{ color: 'rgba(245,240,232,0.35)' }}>{c?.desc}</p>
            </div>
          ))}
        </div>

        {/* Bridge visual */}
        <div className="flex items-center justify-center gap-4 mb-10">
          <div className="text-center">
            <div className="px-5 py-3 mb-2" style={{ border: '1px solid rgba(139,105,20,0.25)' }}>
              <p className="font-mono text-xs font-black tracking-widest uppercase" style={{ color: 'rgba(245,240,232,0.4)' }}>KEYS TO KULLI HAAL</p>
            </div>
            <p className="font-mono text-[9px]" style={{ color: 'rgba(245,240,232,0.2)' }}>Internal Framework</p>
          </div>
          <div className="flex-1 max-w-24 h-px relative" style={{ background: 'linear-gradient(90deg, rgba(139,105,20,0.2), rgba(179,138,42,0.5), rgba(139,105,20,0.2))' }}>
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-1.5 h-1.5 rotate-45" style={{ background: 'rgba(179,138,42,0.6)' }} />
          </div>
          <div className="text-center">
            <div className="px-5 py-3 mb-2" style={{ border: '1px solid rgba(139,105,20,0.25)' }}>
              <p className="font-mono text-xs font-black tracking-widest uppercase" style={{ color: 'rgba(245,240,232,0.4)' }}>ENVIRONMENT DESIGN</p>
            </div>
            <p className="font-mono text-[9px]" style={{ color: 'rgba(245,240,232,0.2)' }}>External World</p>
          </div>
        </div>

        <div className="flex items-center justify-center gap-6">
          <Link href="/ayat-in-creation"
            className="font-mono text-xs tracking-widest uppercase px-6 py-3 transition-colors"
            style={{ background: 'rgba(139,105,20,0.85)', color: '#F5F0E8', border: '1px solid rgba(179,138,42,0.35)' }}
            onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.background = 'rgba(179,138,42,0.95)'; }}
            onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.background = 'rgba(139,105,20,0.85)'; }}
          >
            Continue: Ayat in Creation →
          </Link>
          <Link href="/bridge-environment-design"
            className="font-mono text-[10px] tracking-widest uppercase transition-colors border-b"
            style={{ color: 'rgba(245,240,232,0.3)', borderColor: 'rgba(139,105,20,0.2)' }}
            onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.color = 'rgba(196,149,106,0.7)'; }}
            onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.color = 'rgba(245,240,232,0.3)'; }}
          >
            Full Bridge 01 →
          </Link>
        </div>
      </div>
    </section>
  );
}
